import { useCallback, useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";
import { RiDeleteBinLine } from "react-icons/ri";
import addFile from "@/assets/icon_Address_Card_.png";
import { getDisplayFileName } from "../../utils";

import "./styles.css";

export const DropzoneField = (props) => {
  const {
    htmlFor,
    handleOnChange,
    value,
    title = "file",
    showFilePreview = true,
    dropzoneProps = {},
    disabled = false,
  } = props;

  const { multiple = false } = dropzoneProps;
  const [selectedFiles, setSelectedFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFiles(acceptedFiles);
  }, []);

  // When selectedFiles changes, notify parent via handleOnChange
  useEffect(() => {
    if (selectedFiles.length) {
      handleOnChange(multiple ? selectedFiles : selectedFiles[0]);
    }
  }, [selectedFiles]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...dropzoneProps,
    multiple,
    onDrop,
    accept: {
      "image/*": [], "application/pdf": [], "text/csv": [],
      "application/vnd.ms-excel": [],          // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [] // .xlsx 
    },
    disabled,
  });

  const showDelete =
    !disabled && showFilePreview && (selectedFiles.length > 0 || value);

  // Display filename from selected file or value (if it's a File or string path)
  const displayFileName = useMemo(() => {
    return getDisplayFileName(selectedFiles, value);
  }, [selectedFiles, value]);

  // Clear the selected file and reset parent state
  const clearFile = () => {
    setSelectedFiles([]);
    handleOnChange("");
  };

  return (
    <div className="anvImg_selecTor">
      {showDelete && (
        <div className="kyc_delIconDiv">
          <span>
            <RiDeleteBinLine className="kyc_delIcon" onClick={clearFile} disabled={disabled} />
          </span>
        </div>
      )}
      <div {...getRootProps()}>
        <div className={disabled ? "disabledDropzone" : ""}>
          <input autoFocus {...getInputProps()} />
          <label
            htmlFor={htmlFor}
            className={isDragActive ? "drag_active" : ""}
          >
            <div>
              <img src={addFile} alt="Upload" />
            </div>
            <div className="drpFile_pr">
              {/* Show File Name if file name exists in file array */}
              {displayFileName && showFilePreview ? (
                <>
                  <p className="file-name-ellipsis">{displayFileName}</p>
                  <span className="kyc_delIcon">Change</span>
                </>
              ) : (
                <p>
                  Drop file here or <span>Click to upload</span>
                </p>
              )}
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default DropzoneField;
